module.exports = __webpack_public_path__ + "img/badge-list-thumb-087.fe898b79.png";